// Video optimization utilities
export const getOptimalVideoSettings = (videoUrl, connectionSpeed = 'auto') => {
  const isHLS = videoUrl && videoUrl.includes('.m3u8');
  
  const baseSettings = {
    preload: 'auto',
    playsinline: true,
    crossOrigin: 'anonymous'
  };

  const hlsSettings = {
    enableLowInitialPlaylist: true,
    smoothQualityChange: true,
    overrideNative: true,
    maxBufferLength: connectionSpeed === 'slow' ? 15 : 30,
    maxBufferSize: connectionSpeed === 'slow' ? 30 * 1000 * 1000 : 60 * 1000 * 1000,
    maxBufferHole: 0.5,
    highBufferWatchdogPeriod: 2,
    nudgeOffset: 0.1,
    nudgeMaxRetry: 3,
    maxSeekHole: 2,
    seekHoleNudgeDuration: 0.01,
    stallSkip: 0.05,
    useDevicePixelRatio: true,
    startLevel: connectionSpeed === 'slow' ? 0 : -1
  };

  return {
    ...baseSettings,
    html5: {
      hls: isHLS ? hlsSettings : {},
      nativeVideoTracks: false,
      nativeAudioTracks: false,
      nativeTextTracks: false
    }
  };
};

// Detect connection speed
export const detectConnectionSpeed = () => {
  if ('connection' in navigator) {
    const connection = navigator.connection;
    const effectiveType = connection.effectiveType;
    
    switch (effectiveType) {
      case 'slow-2g':
      case '2g':
        return 'slow';
      case '3g':
        return 'medium';
      case '4g':
        return 'fast';
      default:
        return 'auto';
    }
  }
  return 'auto';
};

// Preload video metadata
export const preloadVideoMetadata = (videoUrl) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.crossOrigin = 'anonymous';
    
    video.onloadedmetadata = () => {
      resolve({
        duration: video.duration,
        videoWidth: video.videoWidth,
        videoHeight: video.videoHeight
      });
    };
    
    video.onerror = reject;
    video.src = videoUrl;
  });
};